import { globalStore } from 'src/stores/global-store';

/**
 * Gets the entry views for the current form, ensuring that if the current entry view is deleted but was cached,
 * it will be included in the returned list of entry views.
 * @returns The entry views for the current form.
 */
export const getEntryViews = () => {
	if (!globalStore.currentView.IsDeleted || globalStore.currentView.Id === undefined)
		return globalStore.currentForm.EntryViews;
	else {
		const entryViews = [...globalStore.currentForm.EntryViews.filter(v => v.Id !== globalStore.currentView.Id), globalStore.currentView];
		return globalStore.sortBySequenceKey(entryViews);
	}
};